import React from 'react';
import PoliceOperations from 'src/components/policeOperations/policeOperations';
import PoliceOperationsLayout from 'src/components/policeOperations/policeOperations-layout';
import { useNavigate, useParams } from "react-router-dom";


const PoliceOperationsPage: React.FC = () => {
  return (
    <PoliceOperationsLayout children={<PoliceOperations/>}></PoliceOperationsLayout>
  );
};

export default PoliceOperationsPage;